/** Thrown when OMS returns `code !== OK` and the hook is configured to skip the global alert banner. */
export class OrderMutationRejectedError extends Error {
  readonly apiCode: string;

  constructor(apiCode: string) {
    super(`Order mutation rejected: ${apiCode}`);
    this.name = "OrderMutationRejectedError";
    this.apiCode = apiCode;
  }
}

export function isOrderMutationRejectedError(
  e: unknown
): e is OrderMutationRejectedError {
  return e instanceof OrderMutationRejectedError;
}
